export enum MaxCountLimitReport {
  MaxReportLimit = 250000 as number,
}
